import { ContactFormModel } from '@apps/landing/src/app/shared/models/contact-form.model';

export const teamDetailsData = {
  title: 'When, with who & how you’ll be working',
  details: [
    {
      icon: 'assets/media/icons/globe-mini-icon.svg',
      title: 'UTC+03:00',
      description: 'Your primary working timezone',
    },
    {
      icon: 'assets/media/icons/clock-mini-icon.svg',
      title: '10:00-18:00 UTC+03:00',
      description: 'Your primary working hours',
    },
    {
      icon: 'assets/media/icons/agile-mini-icon.svg',
      title: 'Agile',
      description: 'Management methodology',
    },
    {
      icon: 'assets/media/icons/community-mini-icon.svg',
      title: '28',
      description: 'Your project’s team size',
    },
  ],
};

export const formFields: ContactFormModel[] = [
  { type: 'text', name: 'firstName', label: 'First name', fullWidth: false, placeholder: 'Type' },
  { type: 'text', name: 'lastName', label: 'Last name', fullWidth: false, placeholder: 'Type' },
  { type: 'email', name: 'email', label: 'E-mail Address', fullWidth: false, placeholder: 'Type' },
  { type: 'phone', name: 'phone', label: 'Phone number', fullWidth: false, placeholder: 'Type' },
  { type: 'file', name: 'cv', label: 'Resume/CV', fullWidth: true },
  { type: 'file', name: 'coverLetter', label: 'Cover Letter', fullWidth: true },
];
